import { useState } from 'react';

import { CorporateBrandingContext } from '../../utils/team';
import CorporateBrandingDrawer from './CorporateBrandingDrawer';

type Props = {
  children: React.ReactNode;
};

const CorporateBrandingProvider: React.FC<Props> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <CorporateBrandingContext.Provider
      value={{
        openCorporateBrandingDrawer: () => setDrawerOpen(true),
      }}
    >
      {children}
      <CorporateBrandingDrawer open={drawerOpen} setOpen={setDrawerOpen} />
    </CorporateBrandingContext.Provider>
  );
};

export default CorporateBrandingProvider;
